import { useLocation } from "react-router";

import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { GenerateCampaignButton } from "../../../../components/FeatureButtons/GenerateCampaignButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import { CampaignOrgUnitsCreateForm } from "../components/forms/CampaignOrgUnitsCreateForm";

export const CampaignOrgUnitsCreateFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk, triggerGenerate } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.CAMPAIGNS, "basicTabsWrite");
    const location = useLocation();
    const { terminalIds, siteIds } = location.state || {};

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.campaignsCreateFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <GenerateCampaignButton isDisabled={!hasWriteAccess} onClick={triggerGenerate} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.CAMPAIGNS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CampaignOrgUnitsCreateForm runSubmit={runSubmit} formAction={formAction} terminals1={terminalIds} sites1={siteIds} />
            </FPageContent>
        </FPage>
    );
};
